import CyberSecurity from '../../../apis/cyberSecurityData';
import { formatDate } from '../../../configs/configs'

// -------------------------- FILTERS ACTIONS -------------------------------
export const addPersonalBoardFilter = (key, value) => {
  return {
    type: 'ADD_PERSONAL_BOARD_FILTER',
    payload: { key, value }
  }
}

export const removePersonalBoardFilter = (key) => {
  return {
    type: 'REMOVE_PERSONAL_BOARD_FILTER',
    payload: key
  }
}

export const resetPersonalBoardFilters = (key) => {
  return {
    type: 'RESET_PERSONAL_BOARD_FILTER',
  }
}

// -------------------------- THREADS LOADING ACTIONS -------------------------------
export const loadChannelThreads = (channelId, callBack) => async (dispatch, getState) => {
  if (channelId) {
    try {
      const response = await CyberSecurity.post(`/pboards/threadsdata`, {
        channelId: channelId,
        filters: getState().personalBoard.filters,
        page: 1
      }, {
        headers: {
          Authorization: 'Bearer ' + getState().accessToken
        }
      })

      dispatch({
        type: 'SET_PERSONAL_CHANNEL_THREADS',
        payload: { channel: channelId, items: response.data.threads, totalCount: response.data.totalCount, page: 1 }
      })
      if (callBack) callBack()
    } catch (error) {
      console.log(error.message)
    }
  }
}

export const loadMoreThreads = (callBack) => async (dispatch, getState) => {
  const activeChannel = getState().personalBoard.activeChannel;

  const page = getState().personalBoard.threads[activeChannel._id].page + 1;

  if (activeChannel && activeChannel._id) {
    try {
      const response = await CyberSecurity.post(`/pboards/threadsdata`, {
        channelId: activeChannel._id,
        filters: getState().personalBoard.filters,
        page: page
      }, {
        headers: {
          Authorization: 'Bearer ' + getState().accessToken
        }
      })

      dispatch({
        type: 'LOAD_MORE_PERSONAL_CHANNEL_THREADS',
        payload: { channel: activeChannel._id, items: response.data.threads, totalCount: response.data.totalCount, page }
      })
      if (callBack) callBack()
    } catch (error) {
      console.log(error.message)
    }
  }
}

// -------------------------- THREADS MANAGING ACTIONS -------------------------------

export const addThread = (threadData, callBack) => async (dispatch, getState) => {

  const response = await CyberSecurity.post('/pboards/threads', threadData, {
    headers: {
      Authorization: `Bearer ${getState().accessToken}`
    }
  })

  dispatch({
    type: 'PERSONAL_THREAD_ADDED',
    payload: response.data
  })

  if (callBack) callBack();

}

export const addToReadLaterThread = (itemId, callBack) => async (dispatch, getState) => {

  const threadData = {
    personalTags: [],
    itemId,
    owner: getState().currentUser._id,
    note: `Bookmarked on ${formatDate(new Date(), 'month day, year')}`
  }

  //get user Bookmarks channel
  const channels = getState().personalBoard.channels;
  const readLaterChannel = channels.find(channel => channel.name === 'Bookmarks');

  if (readLaterChannel) {
    threadData.channelId = readLaterChannel._id;

    const existsResponse = await CyberSecurity.post('/pboards/threads/checkexists', threadData, {
      headers: {
        Authorization: `Bearer ${getState().accessToken}`
      }
    })

    if (existsResponse.data && existsResponse.data.exists === false) {
      CyberSecurity.post('/pboards/threads', threadData, {
        headers: {
          Authorization: `Bearer ${getState().accessToken}`
        }
      })

      if (callBack) callBack();
    }
  }

}

export const editThread = (updates) => async (dispatch, getState) => {

  const response = await CyberSecurity.patch('/pboards/threads', updates, {
    headers: {
      Authorization: 'Bearer ' + getState().accessToken
    }
  })

  dispatch({
    type: 'PERSONAL_THREAD_EDITED',
    payload: response.data
  })

}

export const addNoteToThread = (noteData) => async (dispatch, getState) => {

  const response = await CyberSecurity.post('/pboards/notes', noteData, {
    headers: {
      Authorization: `Bearer ${getState().accessToken}`
    }
  })

  dispatch({
    type: 'PERSONAL_NOTE_TO_THREAD_ADDED',
    payload: response.data
  })

}

export const deleteThread = (threadId) => async (dispatch, getState) => {

  console.log(threadId)
  await CyberSecurity.delete('/pboards/threads', {
    data: { threadId },
    headers: {
      Authorization: `Bearer ${getState().accessToken}`
    }
  })

  dispatch({
    type: 'PERSONAL_THREAD_DELETE',
    payload: threadId
  })

}

export const moveThread = (threadId, channelsIds, action) => async (dispatch, getState) => {

  await CyberSecurity.post('/pboards/threads/move', { threadId, channels: channelsIds, action }, {
    headers: {
      Authorization: `Bearer ${getState().accessToken}`
    }
  })

  dispatch({
    type: 'PERSONAL_THREAD_MOVE',
    payload: { threadId, action, channelsIds }
  })
}


